import apiClient from "QueryClient/axiosClient";

export const getCollegeRecommendations = async () => {
  const response = await apiClient.get(
    "/collegeFinder/getRecommendations"
  );
  return response.data;
};
